<script lang="ts">
    /* eslint-disable svelte/no-at-html-tags */
    import {
        BlockConditionProperty,
        type TBlock,
        type TGetCurrentPropertyValue
    } from '$lib/services/blocks/types';
    import PageBuilderReferences from './PageBuilderReferences.svelte';
    import MfeComponentDebugger from './MfeComponentDebugger.svelte';
    import { shouldRender } from '$src/lib/services/blocks/conditional-blocks';
    import { page } from '$app/state';

    type TProps = {
        blockData: TBlock[];
        cssReferences: string[];
        scriptReferences: string[];
        debug: boolean;
    };

    let { blockData, cssReferences, scriptReferences, debug }: TProps = $props();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getPropertyCurrentValue: TGetCurrentPropertyValue = <T = any,>(
        property: BlockConditionProperty
    ) => {
        switch (property) {
            case BlockConditionProperty.PlayerCountry:
                return page.data.userCountry as T;
        }
    };
</script>

<PageBuilderReferences styles={cssReferences} scripts={scriptReferences} />
{#each blockData as { module, hydrate, payload, markup, mfe, legacyParams, variant }}
    <MfeComponentDebugger {mfe} {module} {debug} {variant}>
        {#if shouldRender(variant, getPropertyCurrentValue)}
            {@html `
            <${mfe}
                component="${module}"
                params="${payload}"
                hydrate="${hydrate}"
                ${legacyParams}
            >
                ${markup}
            </${mfe}>
            `}
        {:else if debug}
            <div class="h-fit w-full">CONDITION NOT MET FOR BLOCK - CHECK DEBUG FOR DETAILS</div>
        {/if}
    </MfeComponentDebugger>
{/each}
